module.exports = __webpack_public_path__ + "img/security-complete.947f15f5.png";